import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BaseModal from 'react-overlays/lib/Modal';
import cn from 'classnames';

import './styles.scss';

import Fade from './Fade';
import Body from './Body';
import Footer from './Footer';

const propTypes = {
  children: PropTypes.any,
  ignoreBackdrop: PropTypes.bool,
  onHide: PropTypes.func,
  show: PropTypes.bool,
  simple: PropTypes.bool,
  title: PropTypes.string,
};

function DialogTransition(props) {
  return <Fade {...props} timeout={150} />;
}

function BackdropTransition(props) {
  return <Fade {...props} timeout={300} />;
}

class Modal extends Component {
  handleDialogClick = (e) => {
    if (e.target !== e.currentTarget || this.props.ignoreBackdrop) return;
    this.props.onHide();
  };

  render() {
    const { children, onHide, show, simple, title } = this.props;

    return (
      <BaseModal
        show={show}
        containerClassName="modal-open"
        transition={DialogTransition}
        backdrop
        backdropTransition={BackdropTransition}
        backdropClassName="modal-backdrop"
      >
        <div
          className={cn('modal', { 'modal-simple': simple })}
          role="dialog"
          style={{ display: 'block' }}
          onClick={this.handleDialogClick}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              {title && (
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                  <button type="button" className="close" aria-label="Close" onClick={onHide}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              )}
              {children}
            </div>
          </div>
        </div>
      </BaseModal>
    );
  }
}

Modal.propTypes = propTypes;
Modal.Body = Body;
Modal.Footer = Footer;

export default Modal;
